import type { SearchableField } from "@salon/types";

export const BUSINESS_SEARCH: SearchableField[] = [
  {
    id: "business.salon_name",
    sectionId: "business",
    labelKey: "search.business.salonName.label",
    descriptionKey: "search.business.salonName.description",
    keywordsKey: "search.business.salonName.keywords",
    anchor: "field-business-salon-name",
  },
  {
    id: "business.address",
    sectionId: "business",
    labelKey: "search.business.address.label",
    descriptionKey: "search.business.address.description",
    keywordsKey: "search.business.address.keywords",
    anchor: "field-business-address",
  },
  {
    id: "business.contact_info",
    sectionId: "business",
    labelKey: "search.business.contactInfo.label",
    descriptionKey: "search.business.contactInfo.description",
    keywordsKey: "search.business.contactInfo.keywords",
    anchor: "field-business-contact-info",
  },
  {
    id: "business.operating_hours",
    sectionId: "business",
    labelKey: "search.business.operatingHours.label",
    descriptionKey: "search.business.operatingHours.description",
    keywordsKey: "search.business.operatingHours.keywords",
    anchor: "field-business-operating-hours",
  },
  {
    id: "business.currency_timezone",
    sectionId: "business",
    labelKey: "search.business.currencyTimezone.label",
    descriptionKey: "search.business.currencyTimezone.description",
    keywordsKey: "search.business.currencyTimezone.keywords",
    anchor: "field-business-currency-timezone",
  },
];
